import React, { Component } from 'react'
import NavBar from './NavBar'
import Footer from './Footer'
import './lastevent.css'
import EventsGrid from './EventsGrid'
import SimpleSlider from './SimpleSlider'




export default class LastEvent extends Component {
  
    render() {
        return (
            <div id="events">
                <NavBar />
                 {/* <EventsGrid />  */}
                <SimpleSlider/>
                <Footer />
            </div>
        )
    }
}
